import React, {useEffect} from "react";
import t from '../../../helpers/t';
import {frontendLocationsActions, alertsActions, useSelector} from "inbooma-api";
import {Biscuit} from "../../../../utils";

const PushChangesButtton = (props) => {

  const _pushChanges = useSelector(state => state.frontend_locations_data);
    useEffect(() => {

        if (_pushChanges.pushChanges.success === "") {            // true or false no matter if a new item is created or an existing item modified
            return;
        }
        if (_pushChanges.pushChanges.success === true) {
            props.showNotification('success',t('changes_success_notification'));
            props.setJobs([]);
        }

        if (_pushChanges.pushChanges.success === false) {
            props.showNotification('warning', t('changes_error_notification'));
        }

        abortButtonRef.current.click();
    }, [_pushChanges]);

  const onButtonClicked = (e) => {
      props.dispatch(frontendLocationsActions.pushChanges({
          token: Biscuit.get('token')
      }));

  };
  const link = "/frontend_locations/jobs";
    const abortButtonRef = React.createRef();

  return (
    <>
        <a id="resetLink" href={link} style={{display:"none"}}>
            <button type="button" ref={abortButtonRef} id="inb-pushChanges-reset-button" className="button hollow secondary right button-abort round" title="Fenster schließen">
                <i className="fi fi-x"></i>
            </button></a>
      <a
          href="#"
          id="inb-c-left-bar-add-push_changes"
          className={"button beautify beautify-" + Biscuit.get('user.client_id')}
          onClick={onButtonClicked}
      >
          <i className="fi fi-page-add"></i>
          <span>
              {t('push_changes',null, 'capital')}
          </span>
      </a>
    </>
  );
};
export default PushChangesButtton;